import { render } from "./PostView.vue?vue&type=template&id=14fce12e&ts=true"
import script from "./PostView.vue?vue&type=script&lang=ts"
export * from "./PostView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__